import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

export default function Fechamento(props) {
  const [usuarioId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const history = props.history;
  const [carrinho, setCarrinho] = useState([]);
  const [opcoesFrete, setOpcoesFrete] = useState([]);
  const [dadosCarrinho, setDadosCarrinho] = useState({});
  const [valorTotalItens, setValorTotalItens] = useState(0);
  const [freteSelecionado, setFreteSelecionado] = useState({});
  const [opcoesParcelas, setOpcoesParcelas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    setCarregando(true);
    api
      .get("carrinhos/carregar", { usuarioId })
      .then((res) => {
        const dadosCarrinho = res[0];

        let valorTotalItens = 0;

        res.forEach((item) => {
          let condEspecial = false;
          let valorUnitarioItem = 0;
          let valorTotalItem = 0;

          item.promocoes
            .filter((p) => p.valida)
            .forEach((p) => {
              condEspecial = true;

              valorUnitarioItem = p.valorCentavos;
              valorTotalItem = valorUnitarioItem * item.quantidade;
              valorTotalItens += valorTotalItem;

              item.condEspecialVenda = p.descricao;
            });

          if (condEspecial) {
            item.valorUnitario = `R$ ${(valorUnitarioItem / 100).toFixed(2)}`;
            item.valorTotal = `R$ ${(valorTotalItem / 100).toFixed(2)}`;
          } else {
            item.valorUnitario = `R$ ${(item.valorItemCentavos / 100).toFixed(
              2
            )}`;
            item.valorTotal = `R$ ${(
              (item.valorItemCentavos * item.quantidade) /
              100
            ).toFixed(2)}`;
            valorTotalItens += item.valorItemCentavos * item.quantidade;
          }
        });

        let carrinhoAtualizado = res.filter((item) => item.quantidade > 0);

        setCarregando(false);
        setCarrinho(carrinhoAtualizado);
        setDadosCarrinho(dadosCarrinho);
        setValorTotalItens(valorTotalItens);
        carregarOpcoesFrete();
      })
      .catch((e) => {
        console.log(e);
        notification(
          "error",
          "Erro ao carregar ao carrinho. Verifique os dados e tente novamente."
        );
      });
  };

  const carregarOpcoesFrete = () => {
    api
      .get("carrinhos/calculoFrete", { usuarioId })
      .then((opcoesFrete) => {
        if (opcoesFrete && opcoesFrete.length > 0) {
          opcoesFrete.forEach((opcao) => {
            opcao.descricao = opcao.voucherFreteGratisId
              ? "VOUCHER DE FRETE GRÁTIS"
              : `${opcao.servico} - ${opcao.valor}`;
          });
          return setOpcoesFrete(opcoesFrete);
        }

        notification(
          "error",
          "Não foi possível obter as opções de frete. Verifique o endereço cadastrado para a escola."
        );
      })
      .catch((e) => {
        console.log(e);
        notification(
          "error",
          "Erro ao carregar as opções de frete. Verifique os dados e tente novamente."
        );
      });
  };

  const confirmarFrete = (form) => {
    opcoesFrete
      .filter((o) => o.servico === form.frete)
      .forEach((o) => {
        const freteSelecionado = { ...o };

        freteSelecionado.valor = Number(o.valor.replace(",", "."));
        freteSelecionado.valor = isNaN(freteSelecionado.valor)
          ? 0
          : freteSelecionado.valor * 100;

        obterCondicoes(freteSelecionado);
        setFreteSelecionado(freteSelecionado);
      });
  };

  const camposFiltros = () => {
    return {
      nome: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Profissional</h4>
            <p>{dadosCarrinho.usuarioNome}</p>
          </div>
        ),
      },
      escola: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Escola</h4>
            <p>{dadosCarrinho.escolaNome}</p>
          </div>
        ),
      },

      frete: freteSelecionado.servico
        ? {
            label: "Componente",
            type: "component",
            value: (
              <div>
                <h4>Frete</h4>
                <p>{freteSelecionado.servico}</p>
              </div>
            ),
            space: 4,
          }
        : {
            label: "Frete",
            type: "select",
            emptyItem: true,
            space: 4,
            array: {
              data: opcoesFrete,
              value: "servico",
              desc: "descricao",
            },
            value: freteSelecionado.servico,
          },
    };
  };

  const fFiltro = {
    form: camposFiltros(),
    title: "Dados para entrega",

    submit: freteSelecionado.servico
      ? undefined
      : {
          label: "Confirmar",
          action: confirmarFrete,
        },

    history,
    close: { close: true, label: "cancelar" },

    customActions: freteSelecionado.servico
      ? [
          {
            label: "Alterar",
            action: () => {
              setFreteSelecionado({});
            },
          },
        ]
      : undefined,
  };

  const camposPagamento = () => {
    return {
      valorTotalItens: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Valor total (itens)</h4>
            <p>R$ {valorTotalItens ? valorTotalItens / 100 : 0}</p>
          </div>
        ),
      },

      totalComFrete: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Valor total (itens + frete)</h4>
            <p>
              R${" "}
              {freteSelecionado.servico
                ? (valorTotalItens + freteSelecionado.valor) / 100
                : "(selecione o frete)"}
            </p>
          </div>
        ),
      },

      parcelamento: freteSelecionado.servico
        ? {
            label: "Parcelamento",
            type: "select",
            emptyItem: true,
            emptyItemText: "(Selecione)",
            space: 4,
            options: opcoesParcelas,
          }
        : {
            label: "Componente",
            type: "component",
            space: 4,
            value: (
              <div>
                <h4>Parcelamento</h4>
                <p>(selecione o frete)</p>
              </div>
            ),
          },
    };
  };

  const fecharPedido = (form) => {
    let valor = freteSelecionado.valor / 100;

    const dadosPedido = {
      usuarioId,
      pagamentoQtdParcelas: Number(form.parcelamento),
      freteServico: freteSelecionado.servico,
      freteValor: valor.toString(),
      freteVoucherFreteGratisId:
        freteSelecionado.servico === "VOUCHER"
          ? freteSelecionado.voucherFreteGratisId
          : 0,
    };

    api
      .put("pedidos/inserir", dadosPedido)
      .then((res) => {
        notification("success", "Pedido criado com sucesso!");
        return history.push(`/app/pedidos-gerenciamento/lista`);
      })
      .catch((err) => {
        const { data } = err;

        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Informações de pagamento inválidas");
          case 3:
            return notification("error", "Informações de frete inválidas");
          case 4:
            return notification("error", "Quantidade de parcelas inválida");
          case 5:
            return notification("error", "Carrinho vazio");
          case 6:
            return notification("error", "Email financeiro inválido");
          case 7:
            return notification("error", "Dia para pagamento inválido");
          case 8:
            return notification("error", "CNPJ inválido");
          case 9:
            return notification("error", "CEP inválido");
          case 10:
            return notification("error", "Opção de frete inválida");
          case 11:
            return notification("error", "Não há opção de frete disponível");
          case 12:
            return notification("error", "Valor de frete inválido");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDadosPagamento = {
    form: camposPagamento(),
    title: "Dados de pagamento",
    submit: carregando
      ? undefined
      : freteSelecionado.servico
      ? {
          label: "Fechar pedido",
          action: fecharPedido,
        }
      : undefined,
  };

  const obterCondicoes = (freteSelecionado) => {
    const opcoesParcelas = [];

    const valorTotalComFrete = valorTotalItens + freteSelecionado.valor;

    api
      .get("carrinhos/condicoesFechamento", {
        escolaId: dadosCarrinho.escolaId,
      })
      .then((parcelas) => {
        for (var i = 1; i <= parcelas.maxParcelas; i++) {
          opcoesParcelas.push({
            value: i,
            desc: `${i}x de R$ ${(valorTotalComFrete / i / 100).toFixed(2)}`,
          });
        }

        setOpcoesParcelas(opcoesParcelas);
      })
      .catch((e) => {
        console.log(e);
        notification(
          "error",
          "Erro ao obter as condições de pagamento. Verifique os dados e tente novamente."
        );
      });
  };

  const tRegistros = {
    title: "Itens",
    columns: [
      {
        name: "produtoNome",
        label: "Produto",
      },
      {
        name: "quantidade",
        label: "Quantidade",
      },
      {
        name: "valorUnitario",
        label: "Valor unitário",
      },
      {
        name: "valorTotal",
        label: "Valor total",
      },
    ],
    array: carrinho,
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fFiltro} />
          <Form formData={fDadosPagamento} />
          <ActionTable structure={tRegistros} />
        </>
      )}
    </div>
  );
}
